const siteSettingConfig = {
    CONTACT_EMAIL: `care@gritzo.com`,
    CONTACT_SUPPORT_NUMBER: `+91 9205 487429`,
    CONTACT_SUPPORT_NUMBER_TEL: `+91 9205487429`,

    GRIEVANCE_OFFICER_EMAIL: `grievance.redressal@brightlifecare.com`,
    GRIEVANCE_OFFICER_NAME: `Brahm Rishi Sharma`,
    GRIEVANCE_OFFICER_DESINATION: `General Manager - Customer Service`,
    GRIEVANCE_OFFICER_NUMBER: `+91 8527 732632`,
    GRIEVANCE_OFFICER_NUMBER_TEL: `+91 8527732632`,

    REGISTERED_OFFICE_ADDRESS: `Unit No. 713, 7th Floor, Devika Tower, Nehru Place, New Delhi 110019`,
    BRIGHT_LIFECARE_ADDRESS: `BRIGHT LIFECARE PVT. LTD. Wing C, 2nd Floor, Tower-B, The Presidency, Anamika Enclave, Sector-14, Mehrauli Gurgaon Road, Opposite Govt. Girls College, Gurugram, Haryana-122001, Gurgaon, Gurugram Haryana-122001`,
    OPERATING_ADDRESS: `1st Floor, Tower B, The Presidency, Opp. Govt. Girls College, Sector 14, MG Road, Gurugram, Haryana 122001`,
    BRIGHT_NUTRICARE_ADDRESS: `Wing A, B and C, 1st Floor, Tower B, The Presidency Tower, Opp. Govt. Girls College, Sector 14, MG Road, Gurugram 122001, Haryana`,
    
    SELLER_EMAIL: `sellers@brightlifecare.com`,
    BRAND_NAME: 'Gritzo',
    WEBSITE_URL: 'https://www.gritzo.com',
    WEBSITE_URL_WWW: 'www.gritzo.com',
    WEBSITE_DOMAIN: 'gritzo.com',
    SEO_DEFAULT_TITLE: `Gritzo: Personalized Nutrition &amp; SuperMilk Protein Drinks for Kids`,
    SEO_DEFAULT_META_DESC: `Get Personalized Health Drink As Per Your Child's Nutritional Needs From Gritzo. A whey based all natural milk drink with 3X Protein without any preservatives or artificial sugar.`,
    PRIMARY_COLOR: '',
    BRIGHT_NUTRICARE: 'Bright Nutricare Private Limited',
    BRIGHT_NUTRICARE_SHORT: 'Bright Nutricare',
    BRIGHT_LIFECARE: 'Bright Lifecare Pvt. Ltd.',
    COPY_RIGHTS: 'gritzo.com',
    SECURITY_EMAIL: 'security@gritzo.com',
    TEST_EMAIL: 'suraj.rathore@brightlifecare.com',
    paymentInfo: {
        "isActive": true,
        "msg": "We've updated our options, and currently, Amex and Diner's Club cards are not accepted."
    },
    FEATURE_LIST: {
        HK_CASH: false,
        WALLET: false,
        SEARCH: false,
        FOOTER_ACTION: false,
        WISHLIST: false,
    },
    SOCIAL_LINKS: {
        insta: ``,
        fb: ``, //currently not available
        twitter: ``, //currently not available
        youtube: ``
    },
    footer: {
        desc: ``,
        socialHeading: ``
    }
};
export default siteSettingConfig;